import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import NLPSentiment from './pages/NLPSentiment/NLPSentiment';
import NBATeam from './pages/NBATeam/NBATeam';
import ImageClassifier from './pages/ImageClassifier/ImageClassifier';
import LSTMPredictor from './pages/LSTMPredictor/LSTMPredictor';
import GANFlower from './pages/GANFlower/GANFlower';
import EnergyForecaster from './pages/EnergyForecaster/EnergyForecaster';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nlp-sentiment" element={<NLPSentiment />} />
        <Route path="/nba-team" element={<NBATeam />} />
        <Route path="/image-classifier" element={<ImageClassifier />} />
        <Route path="/lstm-predictor" element={<LSTMPredictor />} />
        <Route path="/gan-flower" element={<GANFlower />} />
        <Route path="/energy-forecaster" element={<EnergyForecaster />} />
      </Routes>
    </Router>
  );
}

export default App;
